module.exports = __webpack_public_path__ + "static/media/R-150XLHD_CrossSection.686d3e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/fr/R-150XLHD_CrossSection.png
// module id = 491
// module chunks = 0